<template>
  <input :value="modelValue"
         type="color"
         class="color-input"
         @input="onColorInput"
         @change="onColorChange">
</template>

<script>
  import throttle from 'lodash/throttle';
  import Variables from '~/zf/frontend/common/variables/variables';

  /**
   [Vue migration] Developer Note
   This component has a twin version for both Vue 2 and Vue 3 projects.
   When making changes, remember to update and test both versions.
   */
  export default {
    name: 'ColorPicker',
    compatConfig: {
      MODE: 3,
    },
    props: {
      modelValue: {
        type: String,
      },
    },
    emits: ['update:modelValue', 'change'],
    methods: {
      throttleColorChange: throttle(function throttleColorChange(color) {
        this.$emit('update:modelValue', color);
      }, Variables.SHORT_DEBOUNCE),
      onColorInput(event) {
        this.throttleColorChange(event.target.value);
      },
      onColorChange(event) {
        this.$emit('change', event.target.value);
      },
    },
  };
</script>

<style scoped lang="scss">
  .color-input {
    width: 40px;
  }
</style>
